module.exports = __webpack_public_path__ + "img/weal_1.846b6668.jpg";